"use client";
import Link from "next/link";
import { ArrowRight, Clock } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { whatToExpect as data } from "@/lib/data/demo";

const accent = "var(--color-purple)";
const stepAccents = ["var(--color-crimson)", "var(--color-purple)", "var(--color-cyan)", "var(--color-amber)", "var(--color-emerald)"];

export function WhatToExpect() {
  return (
    <Section id="what-to-expect" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-purple)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-12 relative">
          <div className="hidden lg:block absolute top-0 bottom-0 left-[27px] w-px" style={{ background: `linear-gradient(180deg, transparent, color-mix(in oklch, var(--color-crimson) 50%, transparent) 10%, color-mix(in oklch, var(--color-cyan) 50%, transparent) 50%, color-mix(in oklch, var(--color-amber) 50%, transparent) 90%, transparent)` }} aria-hidden />
          <div className="space-y-8">
            {data.steps.map((s, i) => {
              const c = stepAccents[i % stepAccents.length]!;
              return (
                <Reveal key={s.title} delay={i * 100}>
                  <div className="relative flex gap-6 items-start">
                    <div className="shrink-0 relative">
                      <div className="grid place-items-center h-14 w-14 rounded-2xl glass relative z-10" style={{ boxShadow: `0 0 0 4px rgb(var(--bg)), inset 0 0 0 1px color-mix(in oklch, ${c} 35%, transparent)` }}>
                        <Clock className="h-5 w-5" style={{ color: c }} />
                      </div>
                    </div>
                    <div className="flex-1 pt-1">
                      <div className="eyebrow-tiny" style={{ color: c }}>{s.step}</div>
                      <h3 className="mt-1">{s.title}</h3>
                      <p className="mt-3 text-body-sm text-[rgb(var(--fg-muted))] leading-relaxed max-w-2xl">{s.body}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
        <Reveal delay={500}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
